import { Alert, Button, CircularProgress } from "@mui/material";
import { OTPInput } from "@components";
import useOTPStepData from "./otpStepData";
import "./index.scss";

const OTPStep = ({
  otpVal,
  otpError,
  loading,
  handleChange,
  handleSubmit,
  handleResend,
  handleCloseOtpModal,
  classPrefix = "cd-balance", // Default prefix, can be overridden
}) => {
  const { canResend, timer, handleResendWithTimer } = useOTPStepData({
    handleResend,
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <div className={`${classPrefix}-otp-step`}>
      <div className={`${classPrefix}-otp-step__header`}>
        <h3 className={`${classPrefix}-otp-step__title`}>Verify OTP</h3>
        <p className={`${classPrefix}-otp-step__subtitle`}>
          Please enter the 6-digit OTP sent to your registered email to complete
          the transaction
        </p>
      </div>

      <form
        onSubmit={handleFormSubmit}
        className={`${classPrefix}-otp-step__form`}
      >
        <div className={`${classPrefix}-otp-step__input-section`}>
          <OTPInput
            length={6}
            value={otpVal}
            onChange={handleChange}
            error={!!otpError}
            disabled={loading}
            className={`${classPrefix}-otp-step__input`}
          />

          {otpError && (
            <Alert
              severity="error"
              className={`${classPrefix}-otp-step__error-alert`}
            >
              {otpError}
            </Alert>
          )}
        </div>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          className={`${classPrefix}-otp-step__submit-btn`}
          disabled={loading || otpVal?.length !== 6}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Verify OTP"
          )}
        </Button>

        <div className={`${classPrefix}-otp-step__actions`}>
          <Button
            variant="text"
            size="small"
            className={`${classPrefix}-otp-step__resend-btn`}
            onClick={handleResendWithTimer}
            disabled={loading || !canResend}
          >
            {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
          </Button>

          <Button
            variant="text"
            size="small"
            className={`${classPrefix}-otp-step__cancel-btn`}
            onClick={handleCloseOtpModal}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};

export default OTPStep;
